import {makeStyles} from '@material-ui/core/styles';

/* Estilos compartilhados do acompanhamento estatístico (cartões, grade e cores por categoria). */
export const useEstilosAcompanhamento = makeStyles(theme => ({
    kpiGrid: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-evenly',
        rowGap: theme.spacing(2),
        columnGap: theme.spacing(1.5),
        [theme.breakpoints.up('lg')]: {flexWrap: 'nowrap'}
    },
    // Separador vertical entre cards: display flex estica na altura dos cards; some abaixo de lg.
    separadorKpi: {
        display: 'flex',
        [theme.breakpoints.down('md')]: {display: 'none'}
    },
    grafico: {
        position: 'relative',
        height: 260
    },
    semDados: {
        textAlign: 'center',
        color: theme.palette.secondary.dark,
        fontStyle: 'italic',
        padding: theme.spacing(3, 0)
    },
    semDadosPainel: {
        textAlign: 'center',
        color: theme.palette.secondary.dark,
        fontStyle: 'italic',
        padding: theme.spacing(1, 0)
    },
    bubbleTotal: {backgroundColor: theme.palette.primary.main},
    bubbleSucesso: {backgroundColor: theme.palette.quinary.main},
    bubbleErro: {backgroundColor: theme.palette.error.main},
    bubblePendente: {backgroundColor: theme.palette.senary.main},
    bubbleAtencao: {backgroundColor: theme.palette.warning.dark},
    bubbleInfo: {backgroundColor: theme.palette.tertiary.main},
    numTotal: {color: theme.palette.primary.main},
    numSucesso: {color: theme.palette.quinary.main},
    numErro: {color: theme.palette.error.main},
    numPendente: {color: theme.palette.senary.main},
    numAtencao: {color: theme.palette.warning.dark},
    numInfo: {color: theme.palette.tertiary.main},
    listaValor: {fontWeight: 700, marginLeft: theme.spacing(2)}
}));

const SUFIXO_CATEGORIA = {
    sucesso: 'Sucesso',
    erro: 'Erro',
    pendente: 'Pendente',
    atencao: 'Atencao',
    info: 'Info',
    total: 'Total'
};

/* Classes do círculo e do número para a categoria; desconhecida cai em Total. */
export function classesDaCategoria(classes, categoria) {
    const sufixo = SUFIXO_CATEGORIA[categoria] || 'Total';
    return {bubbleClass: classes[`bubble${sufixo}`], valueClass: classes[`num${sufixo}`]};
}
